import React, { useState } from "react";
import { Heart } from "lucide-react";

export const SafeImg = ({ src, alt, className }) => {
  const [tries, setTries] = useState(0);
  if (!src || tries > 2) {
    return (
      <div className={`${className} flex items-center justify-center bg-gradient-to-br from-[#F6E4E6] to-[#FBF5F0]`} data-testid="img-fallback">
        <Heart className="w-10 h-10 text-[#E7A9B0]" fill="#F3D9DC" />
      </div>
    );
  }
  const url = tries ? `${src}${src.includes("?") ? "&" : "?"}r=${tries}` : src;
  return (
    <img
      src={url}
      alt={alt}
      loading="lazy"
      className={className}
      onError={() => setTimeout(() => setTries((t) => t + 1), 800 * (tries + 1))}
    />
  );
};
